<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<!--div class="card" *ngIf="translations && globalUserPreferences?.securitySelected?.storeId != null"-->
<div class="card">
    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">

        <div class="p-col-12 p-md-6">
            <p-panel>
                <!-- LANGUAGE FORM -->
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">

                    <!-- INPUT COORDINACIÓN ID -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">

                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_coordination}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <input type="text" pInputText formControlName="selectedCoordination">
                        </div>
                    </div>


                    <!-- INPUT PERIOD -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">

                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_period}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown id="listStore" [options]="periods" formControlName="selectedPeriod"
                                placeholder="{{translations.lbl_select}} {{translations.lbl_coordination}}"
                                optionLabel="descrip" [showClear]="true" [filter]="true"
                                (onChange)="onChangeUserPreferences()"></p-dropdown>
                        </div>
                    </div>
                </div>

            </p-panel>
        </div>
    </div>

    <br />

    <p-table #dt1 emptyMessage="Registros no existentes" [columns]="colsG" [value]="dataG" [paginator]="true"
        [rows]="40" [showCurrentPageReport]="false" [globalFilterFields]="colsGlI" responsive="true">

        <!-- CAPTION -->
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-left p-jc-between responsive">
                <div>
                    <button type="button" pButton pRipple icon="pi pi-file-excel"
                        (click)="exportExcel(dataG,colsFiI,'Income')" class="p-button-success p-m-2 z-5" pTooltip="XLS"
                        tooltipPosition="bottom"></button>

                    <button type="button" pButton pRipple icon="pi pi-file-pdf"
                        (click)="exportPdf(dataG,colsFiI,'Income')" class="p-button-warning p-m-2" pTooltip="PDF"
                        tooltipPosition="bottom"></button>

                    <!--button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                        (click)="reloadGetListIncome()"></button-->
                </div>

                <div class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </div>
            </div>
        </ng-template>

        <!-- HEADER -->
        <ng-template pTemplate="header" let-columns>
            <tr>
                <ng-container *ngFor="let col of columns">
                    <th [pSortableColumn]="col.field">
                        {{ capitalizeLastElement(col.header) }}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                </ng-container>
            </tr>
        </ng-template>

        <!-- BODY -->
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <ng-container *ngFor="let col of columns">
                    <td>
                        {{ getNestedValue(rowData, col.field) }}
                    </td>
                </ng-container>

                <td>
                    <button pButton pRipple icon="pi pi-play" icon="pi pi-pencil"
                        class="p-button-rounded p-button-warning p-mr-2"
                        (click)="redirectToJrnGuideReferExp(rowData)"></button>
                </td>
            </tr>

        </ng-template>



        <!-- SUMMARY -->
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_there_are}} {{dataG != null ? dataG.length : 0 }}
                {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>

</div>